let body;
let lang;

let button;

let quantity;
let quantityCTA;
let solution;
let solutionCTA;
let price;
let priceInput;

let cap;
let nazione;

let update_cart;
let maggiorazione;
let destinatario;
let cap_errato;
let send_cap;
let send_cap_mobile;
let form_cap;
let formStep;
let totale_post_spedizioni;
let totale_ordine;
let totale_articoli;
let cap_section;
let select_metodo;
let metodo_spedizione_1;
let metodo_spedizione_2;
let metodo_spedizione_3;

let form_to_update;
let removeButton;

let form_salva_ordine;
let btn_salva_ordine;
let cart_id;
let cap_input;

const BRAND = 'Laltrameta';

const VALID_KEYS_FOR_NUMBERS = [37, 38, 39, 40, 8, 46];
const FROM_TO_KEYPAD_NUMBERS = [96, 97, 98, 99, 100, 101, 102, 103, 104, 105];
const FROM_TO_KEYBOARD_NUMBERS = [48, 49, 50, 51, 52, 53, 54, 55, 56, 57];


function centerImageBg(){

	jQuery('.tile-thumb:not(.initialized)')

	.addClass('initialized')

	.each(function(){
		jQuery(this)
		.append('<div class="photo"></div>')
		.children('.photo').css({'background-image': 'url('+ encodeURI(jQuery(this).attr('data-image')) +')'});
	})

}

function populateVariables() {


	body = $('body');
	lang = $('html').attr('lang');

	button = $('.js-add-cart:not(.add-to-cart--disabled)');

	quantity = $('.c-quantity-group');
	quantityCTA = quantity.find('button');
	solution = $('.soluzione--quantity');
	solutionCTA = solution.find('button');
	price = $('.c-price__item');
	priceInput = $('input[name="price"]');

	cap = $('#cap');
	nazione = $('#nazione');

	update_cart = $('.update-cart__button');
	maggiorazione = $('.maggiorazione-col');
	destinatario = $('.maggiorazione-descrizione');
	cap_errato = $('#cap-errato');
	send_cap = $('#send_cap');
	send_cap_mobile = $('#send_cap_mobile');
	form_cap = $('#form_cap');
	formStep = $('#formStep');
	totale_post_spedizioni = $('.totale_post_spedizioni');
	totale_ordine = $('.totale_post_spedizioni .price');
	totale_articoli = $('#totale_articoli');
	cap_section = $('.col--destinatario.cart-col.cart-gen');
	select_metodo = $('.select--metodo');
	metodo_spedizione_1 = $('#metodo_spedizione_1');
	metodo_spedizione_2 = $('#metodo_spedizione_2');
	metodo_spedizione_3 = $('#metodo_spedizione_3');

	form_to_update = $('.form-to-update');
	removeButton = form_to_update.find('.remove-item');

	form_salva_ordine = $('.richiesta--quotazione-form');
	btn_salva_ordine = $('.require-quotation');
	cart_id = $('#cart_id');
	cap_input = $('.js-cap');
}

/**
 * The function that can be called in all modules.
 * Triggers the events.
 *
 * @return {void} [description]
 */
 export function init() {
 	populateVariables();

 	button.off('click').on('click', checkParams);
 	removeButton.on('click', removeFromCart);

 	quantityCTA.on('click', updateQuantity);

 	solutionCTA.on('click', solutionQuantity);
 	send_cap.on('click', toStepTwo);
 	send_cap_mobile.on('click', toStepTwo);
 	select_metodo.on('click', changeMethod);
 	update_cart.on('click', updateCart);
 	btn_salva_ordine.on('click', salvaOrdine);

 	quantity.find('input').on('keyup', checkQuantity);
 	quantity.find('input').on('keyup', showAggiorna);

 	cap.on('keyup', checkCap);
 	nazione.on('change', checkNation);

 	cap_input.on('keypress', checkKeyInput);

 	autoClickOption();
 	centerImageBg();
 }

 const checkKeyInput = function(event) {
 	return (VALID_KEYS_FOR_NUMBERS.indexOf(event.keyCode) > -1 || FROM_TO_KEYPAD_NUMBERS.indexOf(event.keyCode) > -1 || FROM_TO_KEYBOARD_NUMBERS.indexOf(event.keyCode) > -1);
 };

 const showAggiorna = function(event) {
 	update_cart.show();
 };

 const autoClickOption = function() {
 	if (metodo_spedizione_3.is(':checked')) {
 		metodo_spedizione_3.click();
 	}
 };

 const checkQuantity = function(event) {
 	let bool = checkKeyInput(event);

 	if (!bool) {
 		return false;
 	} else {
 		let max = $(this).attr('max');
 		let inputValue = parseInt($(this).val());

 		if (typeof max !== 'undefined' && max != '') {
 			max = parseInt(max);

 			if (inputValue > max) {
 				$(this).val(max);
 				return false;
 			}
 		}
 	}
 };

 let assembleGTMProduct = function(group) {
 	const input = group.querySelectorAll('input, select');
 	let i = input.length - 1;

 	let price, sku, variant, quantity, category, title;

 	for (; i >= 0; i--) {
 		let name = input[i].name;

 		if (name.match(/price/g)) {
 			price = (input[i].value / 100).toFixed(2);
 		} else if (name.match(/(sku)|(codice-articolo)/g)) {
 			sku = input[i].value;
 		} else if (name.match(/color/g)) {
 			variant = input[i].value;
 		} else if (name.match(/quantity/g)) {
 			quantity = parseInt(input[i].value);
 		} else if (name.match(/category/g)) {
 			category = input[i].value;
 		} else if (name.match(/titolo/g)) {
 			title = input[i].value;
 		}
 	}

 	let product = {
 		'id': sku,
 		'name': title,
 		'price': price,
 		'brand': BRAND,
 		'category': category,
 		'quantity': quantity
 	};

 	if (typeof variant !== 'undefined') {
 		product.variant = variant;
 	}

 	return product;
 };

 let removeFromCart = function(event) {
 	const col = this.parentNode;
 	const row = col.parentNode;

 	let ecommerce = {
 		'currencyCode': 'EUR',
 		'remove': {
 			'products': [assembleGTMProduct(row)]
 		}
 	};

 	window.dataLayer.push({
 		'event': 'removeFromCart',
 		'ecommerce': ecommerce
 	});

 	document.location = this.href;
 }

 const salvaOrdine = function(event) {
 	select_metodo.removeClass('input__error_text');

 	$('.preventivo-email').show();

 	if ($('#email-preventivo' ).val() != '') {
 		let callback = function() {
 			form_salva_ordine.submit();
 		};

 		window.dataLayer.push({
 			'event': 'requestQuote'
 		});

 		callback();
 	} else {
 		$('#email-preventivo').addClass('input__error');
 	}
 }

 const updateCart = function(event) {
 	event.preventDefault();

 	form_to_update.submit();
 }

 const checkParams = function(event) {
 	let type = $(this).data('type');

 	if (type == 'prodotto') {
    let form = $(this).closest('form.c-form--atc'); // form del dettaglio

    if (form.length) { // Singolo prodotto
    	let error = false;
    	let color = form.find('[name="color"]');
    	let qta = form.find('[name="quantity"]');
    	let id = form.find('[name="id"]').val();

    	color.removeClass('fill--required');
    	qta.removeClass('fill--required');
    	if (color.val() == '') {
    		error = true;
    		color.addClass('fill--required');
    	}

    	if (qta.val() == 0) {
    		error = true;
    		qta.addClass('fill--required');
    	}

    	if (!error) {
    		button.prop('disabled', true);

    		let ecommerce = {
    			'currencyCode': 'EUR',
    			'add': {
    				'products': [assembleGTMProduct(form[0])]
    			}
    		};

    		let callback = function() {
    			form.submit();
    		};

    		window.dataLayer.push({
    			'event': 'addToCart',
    			'ecommerce': ecommerce
    		});

    		callback();
    	}
    } else { // Archivi prodotto
    	let form = $(this).parent();

    	if (form.find('input[name="colore"]').length) {
    		button.prop('disabled', true);

    		let ecommerce = {
    			'currencyCode': 'EUR',
    			'add': {
    				'products': [assembleGTMProduct(form[0])]
    			}
    		};

    		let callback = function() {
    			form.submit();
    		};

    		window.dataLayer.push({
    			'event': 'addToCart',
    			'ecommerce': ecommerce
    		});

    		callback();
    	} else {
    		$.ajax({
    			url: _url + 'ajax/ajax.modal-prodotto.php',
    			type: 'POST',
    			data: {
    				product: form.find('input[name="codice-articolo"]').val(),
    				price: form.find('input[name="price"]').val(),
    				id: form.find('input[name="id"]').val(),
    				disponibile: form.find('input[name="disponibilita"]').val(),
    				language: lang
    			},
    			success: function (data) {
    				body.append(data);
    				body.addClass('is-modal__open');

    				let modal = $('.m-soluzione');
    				modal.addClass('is-open');

    				$('.c-close-modal, .m-overlay').on('click', () => {
    					modal.removeClass('is-open');
    					body.removeClass('is-modal__open');
    					modal.remove();
    				});

    				body.on('keyup', (e) => {
    					if (e.keyCode == 27 && body.hasClass('is-modal__open')) {
    						modal.removeClass('is-open');
    						body.removeClass('is-modal__open');
    						modal.remove();
    					}
    				});
    			}
    		});
    	}
    }
} else {
	let soluzioneID = $(this).data('soluzione-id');
	let products = [];
	let counter = 0;

	solution.each(function () {
		products[counter] = $(this).data('product') + '||' + $(this).find('input[type="hidden"]').val();
		counter++;
	});

	$.ajax({
		url: _url + 'ajax/ajax.modal-soluzione.php',
		type: 'POST',
		data: {
			products: products,
			ID: soluzioneID,
			language: lang,
			price: priceInput.val()
		},
		success: function(data) {
			body.append(data);
			body.addClass('is-modal__open');

			let modal = $('.m-soluzione');
			modal.addClass('is-open');

			$('.c-close-modal, .m-overlay').on('click', () => {
				modal.removeClass('is-open');
				body.removeClass('is-modal__open');
				modal.remove();
			});

			body.on('keyup', (e) => {
				if (e.keyCode == 27 && body.hasClass('is-modal__open')) {
					modal.removeClass('is-open');
					body.removeClass('is-modal__open');
					modal.remove();
				}
			});

			$('[data-input-single]').on('click', function () {
				$(this).parent().parent().find('[data-single-colors]').toggle();
			});
		}
	});
}
}

const updateQuantity = function(event) {
	let _this = $(this);
	let group = _this.parent();

	let input = group.find('input');
	let inputValue = parseInt(input.val());
	let max = input.attr('max');

  if (_this.hasClass('increase')) { // incrementato dal bottone
  	if (typeof max === 'undefined' || max.trim() === '') {
  		max = parseInt(max);

  		if (inputValue < max) {
  			inputValue++;
  		}
  	} else {
  		inputValue++;
  	}
  } else if (_this.hasClass('decrease') && inputValue > 0) { // decrementato dal bottone
  	inputValue--;
  }

  input.val(inputValue);

  showAggiorna();
}

const solutionQuantity = function(event) {
	let _this = $(this);
	let parent = _this.parent();
	let span = parent.find('span');
	let input = parent.find('input[type="hidden"]');
	let action = (_this.hasClass('increase')) ? 'increase' : 'decrease';
	let products = [];
	let counter = 0;
	let atLeastOneMore = false;

	solution.each(function () {
		products[counter] = $(this).data('product') + '||' + $(this).find('input[type="hidden"]').val();
		counter++;
	});

	$.ajax({
		url: _url + 'ajax/ajax.solution-quantity.php',
		type: 'POST',
		data: { product: parent.data('product') , action: action , products: products , language: lang },
		dataType: 'JSON',
		success: function (data) {
			price.html(data.total);
			span.html(data.qta);
			input.val(data.qta);
			priceInput.val(data.total_raw);

			solution.each(function () {
				if ($(this).find('input[type="hidden"]').val() > 0) {
					atLeastOneMore = true;
				}
			});

			if (!atLeastOneMore) {
				button.off( 'click' );
				button.addClass('add-to-cart--disabled');
			} else if (button.hasClass('add-to-cart--disabled')) {
				button.on('click', checkParams);
				button.removeClass('add-to-cart--disabled');
			}

			if (data.qta == 0) {
				parent.find('button.decrease').attr('disabled', 'disabled');
			} else {
				parent.find('button.decrease').removeAttr('disabled');
			}
		}
	});
};

const checkNation = function(event) {
	let selected = nazione.find('option:selected');

	if (selected.val() !== "") {
		cap.parent().css({
			'display' : 'block',
			'visibility' : 'visible'
		});
	} else {
		cap.parent().css({
			'display' : 'none',
			'visibility' : 'hidden'
		});
	}

	let cap_length = (selected.data('cap')) ? selected.data('cap') : 5;

	cap.attr('maxlength', cap_length);

	cap.val(cap.val().substr(0, cap_length));

	destinatario.html('');
	maggiorazione.html('');

	if (cap.val().length === cap_length || selected.data('regioni') === 0) {
		checkCap(event);
	} else {
		cap_errato.hide();
	}
};

const checkCap = function(event) {
	let selected = nazione.find('option:selected');
	let cap_length = selected.data('cap');

	if (cap.val().length === cap_length || selected.data('regioni') === 0) {
		maggiorazione.html('');

		if (cap_errato.is(':visible')) {
			cap_errato.toggle();
		}

		$.ajax({
			url: _url + 'ajax/ajax.cap.php',
			type: 'POST',
			dataType: 'JSON',
			data: {
				cap: cap.val(),
				nazione: nazione.val(),
				order_id: cart_id.val(),
			},
			success: function (data) {
				if (data.not_found == 'not_found') {
					cap_errato.toggle();
				} else {
					let val = nazione.val();

					let somma_spedizioni = parseInt(data.spese_spedizione);

					if (data.maggiorazione_disagiato != undefined) {
						somma_spedizioni += parseInt(data.maggiorazione_disagiato);

						destinatario.html(_translations.shipping_costs_increase);

						maggiorazione.html(data.spese_spedizione_visual + '<br />' + data.maggiorazione_disagiato_visual);
						maggiorazione.data('raw', data.spese_spedizione + data.maggiorazione_disagiato);
						maggiorazione[0].dataset.raw = data.spese_spedizione + data.maggiorazione_disagiato;
					} else {
						destinatario.html(_translations.shipping_costs);

						maggiorazione.html(data.spese_spedizione_visual);
						maggiorazione.data('raw', data.spese_spedizione);
						maggiorazione[0].dataset.raw = data.spese_spedizione;
					}

					let raw_articoli = parseInt(totale_articoli.data('raw'));
					let somma = raw_articoli + somma_spedizioni;

					totale_ordine[0].dataset.raw = somma;

					let somma_tmp;
					let somma_1;
					let somma_2;
					somma = '€ ' + somma / 100;
					somma_tmp = somma.split('.');
					somma_1 = somma_tmp[0];
					somma_2 = somma_tmp[1];

					if (somma_2 == null) {
						somma_2 = '00';
					}

					if (somma_2.length == 1) {
						somma_2 = somma_2 + '0';
					}
					somma = '';
					somma = somma_1 + ',' + somma_2;

					totale_ordine.html(somma);

					totale_post_spedizioni.css({
						'display' : 'table',
					});

					destinatario.css({
						'visibility' : 'visible',
					});

					totale_post_spedizioni.css({
						'display' : 'table',
						'visibility' : 'visible',
					});
				}
			}
		});
	}
};

const toStepTwo = function(event) {
	event.preventDefault();

	let products = [];

	form_to_update.find('.cart-row[data-type="prodotto"]').each(function(index, el) {
		products.push(assembleGTMProduct(el));
	});


	let ecommerce = {
		'currencyCode': 'EUR',
		'checkout': {
			'actionField': {'step': 1},
			'products': products
		}
	};

	window.dataLayer.push({
		'event': 'checkout',
		'ecommerce': ecommerce
	});

	formStep.submit();
};

const changeMethod = function(event) {
	let metodo;

	setTimeout(function() {
		totale_ordine.html('');
		maggiorazione.html('');
		nazione.val('');
		cap.val('');

    if (metodo_spedizione_1.is(':checked') || metodo_spedizione_3.is(':checked')) { // Corriere & Ultimo indirizzo
    	cap_section.css({
    		'visibility' : 'hidden',
    	});

    	nazione.parent().css({
    		'visibility' : 'visible',
    	});

    	destinatario.css({
    		'visibility' : 'hidden',
    	});

    	totale_post_spedizioni.css({
    		'display' : 'none',
    		'visibility' : 'hidden',
    	});

      if (metodo_spedizione_3.is(':checked')) { // Recupero ultimo indirizzo
      	$.ajax({
      		url: _url + 'ajax/ajax.last_indirizzo.php',
      		type: 'POST',
      		dataType: 'JSON',
      		data: {
      			order_id: cart_id.val(),
      		},
      		success: function(data) {
      			cap.val(data.cap);
      			nazione.val(data.stato);

      			checkNation(event);
      		}
      	});
      } else {
      	cap.parent().css({
      		'visibility' : 'hidden',
      		'display' : 'none',
      	});
      }
    } else if (metodo_spedizione_2.is(':checked')) { // Ritiro in sede
    	cap_section.css({
    		'visibility' : 'hidden',
    	});

    	nazione.parent().css({
    		'visibility' : 'hidden',
    	});

    	cap.parent().css({
    		'visibility' : 'hidden',
    		'display' : 'none',
    	});

    	destinatario.css({
    		'visibility' : 'hidden',
    	});

    	totale_post_spedizioni.css({
    		'visibility' : 'hidden',
    		'display' : 'none',
    	});
    }
}, 100);
};



// WEBPACK FOOTER //
// ./src/js/modules/cart.js